// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","footerContainer":"_2UlwXRgb9ZC6timohoxvgX","footerSocials":"_3vVqB-7L_KI2225U0Pypxd","footerLogo":"_2HTSVhBt5JzoR6jmdo90SR"};